import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { LoadingContainer } from 'app/components/LoadingContainer';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PaymentFail } from './components/PaymentFail';
import { PaymentSuccess } from './components/PaymentSuccess';
import { ReactComponent as EmptyImg } from 'app/assets/img/empty.svg';
import { useHolidayOrderDetail } from '../HolidayCheckout/hooks/useHolidayOrderDetail';
import { IHolidayOrderDetail } from '../HolidayCheckout/types';
export const HolidayPaymentCallback = () => {
  const location = useLocation();
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [detailOrder, setDetailOrder] = useState<IHolidayOrderDetail | null>(
    null,
  );
  const { onFetchOrderDetail, isLoading } = useHolidayOrderDetail({
    shouldValidate: false,
    onSuccess: response => {
      setDetailOrder(response);
    },
  });
  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const orderId = search.get('vnp_TxnRef');
    const resultCode = search.get('result_code');
    setIsSuccess(resultCode === '1');
    if (orderId) onFetchOrderDetail({ payloadData: { orderCode: orderId } });
  }, [location]);
  return (
    <div>
      <LoadingContainer loading={isLoading}>
        <ContainerFluid>
          {!isLoading && detailOrder ? (
            <>
              {!isSuccess ? (
                <PaymentFail detailOrder={detailOrder} />
              ) : detailOrder !== undefined ? (
                <PaymentSuccess detailOrder={detailOrder} />
              ) : (
                <div />
              )}
            </>
          ) : (
            <>
              <EmptyImg style={{ margin: 'auto', marginTop: 30 }} />
            </>
          )}
        </ContainerFluid>
      </LoadingContainer>
    </div>
  );
};
